// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Parser from "../Data.Argonaut.Decode.Parser/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Encoders from "../Data.Argonaut.Encode.Encoders/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Codec from "../Data.Codec/index.js";
import * as Data_Codec_Argonaut from "../Data.Codec.Argonaut/index.js";
import * as Data_Codec_Argonaut_Common from "../Data.Codec.Argonaut.Common/index.js";
import * as Data_Codec_Argonaut_Record from "../Data.Codec.Argonaut.Record/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HTTP_Method from "../Data.HTTP.Method/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Effect_Random from "../Effect.Random/index.js";
import * as Fusion_API_Util from "../Fusion.API.Util/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_Util from "../Fusion.Util/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Test_Spec from "../Test.Spec/index.js";
import * as Test_Spec_Assertions from "../Test.Spec.Assertions/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Fusion_Data_Bytes.encodeJsonBytes);
var decodeArray = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeJsonJson);
var encodeJsonArray = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeJsonJson);
var jsonCodec = /* #__PURE__ */ Fusion_Util.jsonCodec(decodeArray)(encodeJsonArray);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEither);
var jsonCodec1 = /* #__PURE__ */ Fusion_Util.jsonCodec(Fusion_Data_Bytes.decodeJsonBytes)(Fusion_Data_Bytes.encodeJsonBytes);
var startTimeIsSymbol = {
    reflectSymbol: function () {
        return "startTime";
    }
};
var loadedBytesIsSymbol = {
    reflectSymbol: function () {
        return "loadedBytes";
    }
};
var jsonCodec2 = /* #__PURE__ */ Fusion_Util.jsonCodec(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(decodeArray)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(loadedBytesIsSymbol)()())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(encodeJsonArray))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(loadedBytesIsSymbol)())());
var jsonCodec3 = /* #__PURE__ */ Fusion_Util.jsonCodec(Data_Argonaut_Decode_Class.decodeJsonNumber)(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var describe = /* #__PURE__ */ Test_Spec.describe(Data_Identity.monadIdentity);
var it = /* #__PURE__ */ Test_Spec.it(Data_Identity.monadIdentity)(Test_Spec.exampleMUnit);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var lastDurationSecIsSymbol = {
    reflectSymbol: function () {
        return "lastDurationSec";
    }
};
var bytesIsSymbol = {
    reflectSymbol: function () {
        return "bytes";
    }
};
var durationSinceStartIsSymbol = {
    reflectSymbol: function () {
        return "durationSinceStart";
    }
};
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)();
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var convertDuration = /* #__PURE__ */ Data_Time_Duration.convertDuration(Data_Time_Duration.durationSeconds)(Fusion_Data_Duration.durationDuration);
var fromStr = /* #__PURE__ */ Fusion_Data_Timestamp.fromStr();
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var replicateA = /* #__PURE__ */ Data_Unfoldable.replicateA(Effect_Aff.applicativeAff)(Data_Unfoldable.unfoldableArray)(Data_Traversable.traversableArray);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var encodeJson1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeJsonJNumber)))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil)({
    reflectSymbol: function () {
        return "seconds";
    }
})())({
    reflectSymbol: function () {
        return "nanos";
    }
})())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(startTimeIsSymbol)())(loadedBytesIsSymbol)())(lastDurationSecIsSymbol)())());
var now = /* #__PURE__ */ WE_Class_Time.now(WE_Class_Time.monadTimeAff);
var log = /* #__PURE__ */ Effect_Class_Console.log(Effect_Aff.monadEffectAff);
var show1 = /* #__PURE__ */ Data_Show.show(Fusion_Data_Duration.showDuration);
var queryCodecUploadProgressQuery = /* #__PURE__ */ (function () {
    var getKey = function (key) {
        return function (decode) {
            return function (queryPairs) {
                var maybeResult = Data_Array.findMap(function (v) {
                    var $162 = v.value0 === key;
                    if ($162) {
                        return new Data_Maybe.Just(v.value1);
                    };
                    return Data_Maybe.Nothing.value;
                })(queryPairs);
                if (maybeResult instanceof Data_Maybe.Nothing) {
                    return pure(Data_Maybe.Nothing.value);
                };
                if (maybeResult instanceof Data_Maybe.Just && maybeResult.value0 instanceof Data_Maybe.Just) {
                    return map(Data_Maybe.Just.create)(decode(maybeResult.value0.value0));
                };
                return new Data_Either.Left("Key specified without value");
            };
        };
    };
    var enc = function (v) {
        return Data_Array.catMaybes([ map1(function (val) {
            return new Data_Tuple.Tuple("from", new Data_Maybe.Just(show(unwrap(val))));
        })(v.from), map1(function (val) {
            return new Data_Tuple.Tuple("to", new Data_Maybe.Just(show(unwrap(val))));
        })(v.to) ]);
    };
    var dec = function (q) {
        return bind(getKey("from")((function () {
            var $191 = map(Data_Time_Duration.Seconds);
            var $192 = Data_Either.note("Not a number");
            return function ($193) {
                return $191($192(Data_Number.fromString($193)));
            };
        })())(q))(function (from) {
            return bind(getKey("to")((function () {
                var $194 = map(Data_Time_Duration.Seconds);
                var $195 = Data_Either.note("Not a number");
                return function ($196) {
                    return $194($195(Data_Number.fromString($196)));
                };
            })())(q))(function (to) {
                return pure({
                    from: from,
                    to: to
                });
            });
        });
    };
    return Data_Codec["codec$prime"](dec)(enc);
})();
var codecLoadedBytes = /* #__PURE__ */ (function () {
    var enc = function (v) {
        return Data_Argonaut_Encode_Encoders.encodeArray(identity)([ Data_Codec.encode(Fusion_Data_Duration.jsonCodecSeconds)(v.durationSinceStart), encodeJson(v.bytes) ]);
    };
    var dec = function (j) {
        return bind(Data_Codec.decode(jsonCodec)(j))(function (arr) {
            return bind((function () {
                if (arr.length === 2) {
                    return pure(new Data_Tuple.Tuple(arr[0], arr[1]));
                };
                return throwError(new Data_Codec_Argonaut.TypeMismatch("Expecting two fields"));
            })())(function (v) {
                return bind(Data_Codec.decode(Fusion_Data_Duration.jsonCodecSeconds)(v.value0))(function (durationSinceStart) {
                    return bind(Data_Codec.decode(jsonCodec1)(v.value1))(function (bytes) {
                        var lb = {
                            durationSinceStart: durationSinceStart,
                            bytes: bytes
                        };
                        return pure(lb);
                    });
                });
            });
        });
    };
    return Data_Codec.codec(dec)(enc);
})();
var codecUploadProgressResponse = /* #__PURE__ */ (function () {
    var codecSlice = Data_Codec_Argonaut_Record.object()(Data_Codec_Argonaut_Record.rowListCodecCons(Data_Codec_Argonaut_Record.rowListCodecCons(Data_Codec_Argonaut_Record.rowListCodecNil)()()(startTimeIsSymbol))()()(loadedBytesIsSymbol))("UploadProgressResponse Slice")({
        loadedBytes: Data_Codec_Argonaut_Common.nonEmptyArray(codecLoadedBytes),
        startTime: Fusion_Util.jsonCodec(Fusion_Data_Timestamp.decodeJsonTimestamp)(Fusion_Data_Timestamp.encodeJsonTimestamp)
    });
    var dec = function (json) {
        return bind(Data_Codec.decode(jsonCodec2)(json))(function (v) {
            return bind(Data_Either.note(new Data_Codec_Argonaut.TypeMismatch("Expected an element"))(Data_Array.index(Data_Array_NonEmpty.last(v.loadedBytes))(0)))(function (v1) {
                return bind(map(Data_Time_Duration.Seconds)(Data_Codec.decode(jsonCodec3)(v1)))(function (v2) {
                    return bind(Data_Codec.decode(codecSlice)(json))(function (v3) {
                        return pure({
                            loadedBytes: v3.loadedBytes,
                            startTime: v3.startTime,
                            lastDurationSec: v2
                        });
                    });
                });
            });
        });
    };
    var enc = function (v) {
        return Data_Codec.encode(codecSlice)({
            loadedBytes: v.loadedBytes,
            startTime: v.startTime
        });
    };
    return Data_Codec["codec$prime"](dec)(enc);
})();
var getUploadProgress = function (mkCnError) {
    return function (mkReError) {
        return function (baseUrl) {
            return function (query) {
                return Fusion_API_Util.mkClient({
                    baseUrl: baseUrl,
                    method: Data_HTTP_Method.GET.value,
                    path: [  ],
                    token: Data_Maybe.Nothing.value,
                    query: new Data_Maybe.Just(query),
                    body: Data_Maybe.Nothing.value,
                    encodeBody: Data_Function["const"](Data_Argonaut_Core.jsonNull),
                    decodeResponse: Data_Codec.decode(codecUploadProgressResponse),
                    encodeQuery: Data_Codec.encode(queryCodecUploadProgressQuery),
                    mkCnError: mkCnError,
                    mkReError: mkReError
                });
            };
        };
    };
};
var spec = /* #__PURE__ */ describe("Fusion.API.Oxi")(/* #__PURE__ */ describe("codecUploadProgressResponse")(/* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(/* #__PURE__ */ Test_Spec.bindSpecT(Data_Identity.bindIdentity))(/* #__PURE__ */ it("no rounding errors")(/* #__PURE__ */ (function () {
    var json = Data_Either["fromRight$prime"](function (v) {
        return Partial_Unsafe.unsafeCrashWith("invalid json string");
    })(Data_Argonaut_Decode_Parser.parseJson(" \x0a              {\x0a                \"loadedBytes\": [ [ 0.893133322, 16384 ], [ 0.894197162, 16384 ], [ 0.894223708, 16384 ] ],\x0a                \"lastDurationSec\": 0.894223708,\x0a                \"startTime\": { \"seconds\": 1741096862, \"nanos\": 637626030 }\x0a              }\x0a            "));
    return Test_Spec_Assertions.shouldEqual(Effect_Aff.monadThrowAff)(Data_Either.showEither(Data_Codec_Argonaut.showJsonDecodeError)(showRecord(Data_Show.showRecordFieldsCons(lastDurationSecIsSymbol)(Data_Show.showRecordFieldsCons(loadedBytesIsSymbol)(Data_Show.showRecordFieldsConsNil(startTimeIsSymbol)(Fusion_Data_Timestamp.showTimestamp))(Data_Array_NonEmpty_Internal.showNonEmptyArray(showRecord(Data_Show.showRecordFieldsCons(bytesIsSymbol)(Data_Show.showRecordFieldsConsNil(durationSinceStartIsSymbol)(Fusion_Data_Duration.showDuration))(Fusion_Data_Bytes.showBytes)))))(Data_Time_Duration.showSeconds))))(Data_Either.eqEither(Data_Codec_Argonaut.eqJsonDecodeError)(eqRec(Data_Eq.eqRowCons(Data_Eq.eqRowCons(eqRowCons(startTimeIsSymbol)(Fusion_Data_Timestamp.eqTimestamp))()(loadedBytesIsSymbol)(Data_Array_NonEmpty_Internal.eqNonEmptyArray(eqRec(Data_Eq.eqRowCons(eqRowCons(durationSinceStartIsSymbol)(Fusion_Data_Duration.eqDuration))()(bytesIsSymbol)(Fusion_Data_Bytes.eqBytes)))))()(lastDurationSecIsSymbol)(Data_Time_Duration.eqSeconds))))(Data_Codec.decode(codecUploadProgressResponse)(json))(new Data_Either.Right({
        loadedBytes: fromJust(Data_Array_NonEmpty.fromArray([ {
            bytes: Fusion_Data_Bytes.fromInt(16384),
            durationSinceStart: convertDuration(0.893133322)
        }, {
            bytes: Fusion_Data_Bytes.fromInt(16384),
            durationSinceStart: convertDuration(0.894197162)
        }, {
            bytes: Fusion_Data_Bytes.fromInt(16384),
            durationSinceStart: convertDuration(0.894223708)
        } ])),
        lastDurationSec: 0.894223708,
        startTime: fromStr("1741096862637626030")
    }));
})()))(function () {
    return it("bench")(bind1(bind1(replicateA(100000)(liftEffect(function __do() {
        var dur = Effect_Random.random();
        var bytes = Effect_Random.random();
        return [ dur, bytes ];
    })))(function (v) {
        return pure2(encodeJson1({
            loadedBytes: v,
            lastDurationSec: 0.894223708,
            startTime: {
                seconds: 1.741096862e9,
                nanos: 6.3762603e8
            }
        }));
    }))(function (v) {
        return bind1(now)(function (startTime) {
            var result = Data_Codec.decode(codecUploadProgressResponse)(v);
            return bind1(now)(function (endTime) {
                var diff = Fusion_Data_Timestamp.diff(endTime)(startTime);
                return log(show1(diff));
            });
        });
    }));
})));
export {
    codecLoadedBytes,
    getUploadProgress,
    spec
};
